import { Loader2, Siren, AlertTriangle } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";

export default function RedConfirmDialog({
  open,
  onOpenChange,
  address,
  clientName,
  submitting,
  onSubmit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="red-confirm-dialog"
        className="max-w-[440px] rounded-[20px] border-red-200"
        style={{ background: "#FEF2F2" }}
      >
        <DialogHeader>
          <div className="flex items-center gap-2">
            <span
              className="flex h-9 w-9 items-center justify-center rounded-full text-white"
              style={{ background: "#EF4444" }}
            >
              <Siren size={18} strokeWidth={2.4} />
            </span>
            <DialogTitle className="text-[20px] font-bold text-[#7F1D1D]">
              Déclencher une URGENCE ?
            </DialogTitle>
          </div>
          <DialogDescription className="mt-1 text-[13.5px] text-red-700/80 leading-snug">
            Toute l'équipe sera alertée immédiatement (email, SMS et notification
            push prioritaire). À utiliser uniquement en cas de danger.
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-[12px] border border-red-200 bg-white px-4 py-3 text-[13px]">
          <p className="font-semibold text-slate-700">Adresse</p>
          <p className="mt-0.5 text-slate-700">{address || "—"}</p>
          {clientName ? (
            <>
              <p className="mt-2 font-semibold text-slate-700">Client</p>
              <p className="mt-0.5 text-slate-700">{clientName}</p>
            </>
          ) : null}
        </div>

        <div className="flex items-start gap-2 rounded-[10px] bg-amber-50 px-3 py-2 text-[12px] text-amber-800">
          <AlertTriangle size={14} className="mt-0.5 shrink-0" />
          <span>
            Si vous êtes en danger immédiat, composez le <strong>17</strong>.
            Cette urgence informe l'équipe pour qu'elle réagisse aussi.
          </span>
        </div>

        <DialogFooter className="mt-1 flex gap-2 sm:gap-2">
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            disabled={submitting}
            className="flex-1 rounded-[14px] border border-slate-200 bg-white px-5 py-3 text-[14px] font-semibold text-slate-700 transition hover:bg-slate-50 disabled:opacity-50"
            data-testid="red-cancel"
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={onSubmit}
            disabled={submitting}
            className="flex-1 rounded-[14px] px-5 py-3 text-[14px] font-bold text-white transition disabled:opacity-70"
            style={{
              background: "#EF4444",
              boxShadow: "0 4px 18px -2px rgba(239,68,68,0.55)",
            }}
            data-testid="red-submit"
          >
            {submitting ? (
              <span className="inline-flex items-center justify-center gap-2">
                <Loader2 size={16} className="animate-spin" />
                Déclenchement…
              </span>
            ) : (
              "Confirmer l'urgence"
            )}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
